"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gsap_1 = __importDefault(require("gsap"));
class InfoSlider {
    element;
    slider;
    isInit = false;
    marker = document.createElement('div');
    adjust = () => {
        gsap_1.default.to(this.slider, {
            top: this.element.getBoundingClientRect().bottom + 5,
            duration: 0,
            height: (window.innerHeight - this.element.getBoundingClientRect().bottom - 25),
        });
    };
    constructor(element) {
        if (typeof element === 'string') {
            element = document.querySelector(element);
            if (!element) {
                throw new Error('Element not found for info slider');
            }
        }
        this.element = element;
        this.element.classList.add('info-slider-trigger');
        this.slider = this.element.dataset.infoSliderTrigger ? document.querySelector(this.element.dataset.infoSliderTrigger) : null;
        if (!this.slider) {
            throw new Error('Slider not found for info slider');
        }
        const button = document.createElement('button');
        button.classList.add('info-slider-close-internal');
        const icon = document.createElement('span');
        icon.classList.add('icon');
        icon.textContent = 'close';
        button.appendChild(icon);
        button.addEventListener('click', (e) => {
            this.close();
        });
        if (!this.slider.querySelector('.info-slider-close'))
            this.slider.appendChild(button);
        else {
            this.slider.querySelector('.info-slider-close')?.addEventListener('click', (e) => {
                this.close();
            });
        }
        this.slider.remove();
        this.slider.classList.remove('hidden');
        this.element.addEventListener('click', (e) => {
            e.stopPropagation();
            console.log(this.slider);
            if (this.slider?.classList.contains('open')) {
                this.close();
            }
            else {
                this.open();
            }
        });
        this.slider.open = this.open.bind(this);
        this.slider.close = this.close.bind(this);
        this.element.open = this.open.bind(this);
        this.element.close = this.close.bind(this);
    }
    open() {
        document.body.appendChild(this.slider);
        this.slider?.classList.add('open');
        this.element.classList.add('open');
        this.slider?.querySelector('.info-slider-content')?.classList.add('loading');
        gsap_1.default.fromTo(this.slider, { x: '120%' }, {
            duration: 0.5,
            x: 0,
            ease: 'power2.inOut',
            onComplete: () => {
                if (this.element.dataset.infoSliderOnCreate && !this.isInit) {
                    const x = this.element.dataset.infoSliderOnCreate;
                    window[x](this.slider);
                    this.isInit = true;
                }
                if (this.element.dataset.infoSliderOnOpen) {
                    const x = this.element.dataset.infoSliderOnOpen;
                    window[x](this.slider);
                }
                this.slider?.querySelector('.info-slider-content')?.classList.remove('loading');
            }
        });
    }
    close() {
        gsap_1.default.to(this.slider, {
            duration: 0.5, x: '120%', ease: 'power2.inOut', onComplete: () => {
                this.slider?.remove();
                this.slider?.classList.remove('open');
                this.element.classList.remove('open');
            }
        });
    }
}
document.querySelectorAll('[data-info-slider-trigger]').forEach((el) => {
    new InfoSlider(el);
});
